import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVideoStop = () => {
  return (
    <g>
      <path d="M14.951.017 1.051 0C.47 0 0 .47 0 1.05v13.9C0 15.53.47 16 1.05 16h13.9c.58 0 1.05-.47 1.05-1.05V1.067c0-.58-.47-1.05-1.049-1.05zM1.5 1.501l13 .015V14.5h-13V1.501z" />
    </g>
  );
};

export default withIcon(IconVideoStop);
